export default __webpack_public_path__ + "img/partnership2-5622483599df74ea5890fcb2e7739dc3.png";